import { useCallback } from 'react';

import { httpGetPlaylistsByPlaylistId } from '@iconik-io/iconik-api/src/services/assets';

import type { AppDispatch } from '../../../redux/types';
import { useEntity } from '../entity/use_entity';

export const usePlaylist = (playlistId: string | undefined) => {
  const getItem = useCallback((dispatch: AppDispatch, primaryId: string) => {
    return dispatch(httpGetPlaylistsByPlaylistId(primaryId));
  }, []);

  return useEntity({
    entityType: 'playlists',
    primaryId: playlistId,
    getItem,
  });
};
